import { Checkbox as BaseCheckbox } from '@base-ui/react/checkbox';
import { Check } from 'lucide-react';
import type { ComponentProps, ReactNode } from 'react';
import { cva, cx, type VariantProps } from '@/cva.config';

const checkboxRootVariants = cva({
  base: 'flex shrink-0 items-center justify-center rounded-sm border border-border bg-surface transition-colors data-checked:border-accent data-checked:bg-accent data-unchecked:hover:border-border-active',
  defaultVariants: { size: 'sm' },
  variants: {
    size: {
      md: 'size-4',
      sm: 'size-3.5',
      xs: 'size-3',
    },
  },
});

const checkboxIconVariants = cva({
  base: 'text-white',
  defaultVariants: { size: 'sm' },
  variants: {
    size: {
      md: 'size-3.5',
      sm: 'size-3',
      xs: 'size-2.5',
    },
  },
});

export interface CheckboxProps
  extends Omit<ComponentProps<typeof BaseCheckbox.Root>, 'children'>,
    VariantProps<typeof checkboxRootVariants> {
  children?: ReactNode;
}

export const Checkbox = ({
  children,
  className,
  name,
  size,
  ...rest
}: CheckboxProps) => (
  <BaseCheckbox.Root
    className={cx(checkboxRootVariants({ size }), className)}
    id={name}
    name={name}
    {...rest}
  >
    <BaseCheckbox.Indicator>
      {children ?? (
        <Check className={checkboxIconVariants({ size })} strokeWidth={3} />
      )}
    </BaseCheckbox.Indicator>
  </BaseCheckbox.Root>
);
